import { backend } from './backend';

export const isAuthenticated = async () => {
    let r = await backend({ url: 'auth/isauthenticated', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const setYear = async (year) => {
    let r = await backend({ url: 'auth/setyear/?year=' + year, method: "POST" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const getStudent = async () => {
    let r = await backend({ url: 'auth/student', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const updateStudent = async (student) => {
    let r = await backend({ url: 'student/update', method: "POST", data: student });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const getHomePage = async () => {
    let r = await backend({ url: 'school/homepage', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const getSchool = async () => {
    let r = await backend({ url: 'school/current', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const getStudyItems = async () => {
    let r = await backend({ url: 'studyitem/items', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const getEnrollStudyItems = async () => {
    let r = await backend({ url: 'studyitem/eitems', method: "GET" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const deleteEnrollStudyItem = async (id) => {
    let r = await backend({ url: 'studyitem/delete/?id=' + id, method: "POST" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}

export const enrollItem = async (id) => {
    let r = await backend({ url: 'studyitem/enroll/?id=' + id, method: "POST" });
    if (r.status && r.status === 200)
        return r.data;

    return null;
}




